import { useTheme } from '@mui/material/styles';
import ExitButton from 'components/button/ExitButton';
import ComptrollerIcon from 'assets/icons/comptroller';
import { filterOptionLabel } from 'pages/globals/global';
import ActionButton from 'components/button/ActionButton';
import AddIconButton from 'components/button/AddIconButton';
import { Flex, Form, Input, InputNumber, Select } from 'antd';
import DeleteIconButton from 'components/button/DeleteIconButton';
import { operandOption, assignmentTypeOption } from '../hooks/useSolutionConditionHook';
import { Box, Stack, Table, Dialog, TableRow, TableBody, TableCell, DialogTitle, DialogContent, TableContainer } from '@mui/material';

const ConditionSetModal = ({
	open,
	form,
	type,
	onClose,
	SLAList,
	disabled,
	editList,
	structure,
	timestamp,
	parentOpt,
	nameOption,
	// parentField,
	prevIndexMap,
	handleDelete,
	parentFields,
	mapInputType,
	dropDownLabel,
	controlListMap,
	setPrevIndexMap,
	finalPeopleOptions,
}) => {
	const theme = useTheme();

	return (
		<Dialog
			keepMounted
			open={open}
			maxWidth="md"
			fullWidth={true}
			fullScreen={false}
			aria-labelledby="draggable-dialog-title"
			sx={{ zIndex: '9999', '.MuiPaper-root': { borderRadius: '4px' } }}
		>
			<Box
				sx={{
					height: '48px',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'space-between',
					bgcolor: 'header.background.primary',
					borderBottom: `1px solid ${theme.palette.divider}`,
				}}
			>
				<Box sx={{ display: 'flex', alignItems: 'center' }}>
					<DialogTitle
						sx={{
							py: 0,
							gap: '8px',
							display: 'flex',
							fontSize: '16px',
							alignItems: 'center',
							color: 'common.white',
							fontWeight: '600 !important',
						}}
					>
						<ComptrollerIcon width="20px" height="20px" color="#fff" />
						Condition Configuration
					</DialogTitle>
				</Box>

				<Box sx={{ mr: 3, display: 'flex', alignItems: 'center', gap: '12px' }}>
					<ExitButton
						handleClose={() => {
							form.validateFields()
								.then(() => {
									onClose();
								})
								.catch((error) => {
									console.log('Invalid:', error);
								});
						}}
					/>
				</Box>
			</Box>

			<DialogContent
				sx={{
					pb: '0',
					pt: '8px',
				}}
			>
				<Box
					onMouseDown={(e) => e.stopPropagation()}
					onClick={(e) => e.stopPropagation()}
					sx={{
						mb: '20px',
					}}
				>
					<TableContainer>
						<Table
							aria-labelledby="solutionTaskTable"
							sx={{
								'& .MuiTableCell-root': {
									borderBottom: 'none',
								},
								'& .MuiTableRow-root': {
									borderBottom: '1px solid #f0f0f0',
								},
							}}
						>
							<TableBody sx={{ overflowX: 'auto' }}>
								{parentFields?.map((parentField, index) => (
									<TableRow key={parentField.key}>
										<TableCell sx={{ borderRight: '1px solid #f0f0f0' }}>
											<Form.List layout="vertical" name={[parentField.name, 'lynApprovalConditions']} initialValue={[{}]}>
												{(subFields1, subOpt1) => (
													<Flex justify="flex-start" align="center" gap="small">
														{subFields1.map((subField1, nestkey) => (
															<Flex key={subField1.key} justify="space-between" align="center" gap="small">
																<Form.Item
																	layout="vertical"
																	label="Condition Field"
																	style={{ width: '9.5rem' }}
																	name={[subField1.name, 'key']}
																	validateStatus={
																		index >= prevIndexMap[form.getFieldValue(['solutionTaskCode'])] ? 'error' : ''
																	}
																	rules={[
																		{
																			required: true,
																			message: 'Field Name is required',
																		},
																	]}
																>
																	<Select
																		showSearch
																		allowClear
																		autoComplete="off"
																		style={{ width: '100%' }}
																		filterOption={filterOptionLabel}
																		placeholder="Select from the list"
																		getPopupContainer={(node) => node.closest('.MuiDialog-container')}
																		onSelect={() => {
																			form.setFieldValue(
																				[
																					'conditionPeopleSet',
																					index,
																					'lynApprovalConditions',
																					nestkey,
																					'operand',
																				],
																				undefined
																			);
																		}}
																		options={nameOption?.map((value, i) =>
																			value?.label === 'Action'
																				? {
																						label: value.label + ' (' + value?.value + ')',
																						value: value?.value,
																						key: i,
																					}
																				: {
																						label: value.label,
																						value: value?.value,
																						key: i,
																					}
																		)}
																	/>
																</Form.Item>

																<Form.Item
																	label="Operation"
																	layout="vertical"
																	style={{ width: '9.5rem' }}
																	name={[subField1.name, 'operation']}
																	rules={[
																		{
																			required: true,
																			message: 'Operation is required',
																		},
																	]}
																	validateStatus={
																		index >= prevIndexMap[form.getFieldValue(['solutionTaskCode'])] ? 'error' : ''
																	}
																>
																	<Select
																		showSearch
																		allowClear
																		autoComplete="off"
																		style={{ width: '100%' }}
																		filterOption={filterOptionLabel}
																		placeholder="Select from the list"
																		getPopupContainer={(node) => node.closest('.MuiDialog-container')}
																		options={operandOption.map((value, i) => ({
																			label: value.name,
																			value: value?.value,
																			key: i,
																		}))}
																	/>
																</Form.Item>

																<Form.Item
																	shouldUpdate={(prevValues, currentValues) =>
																		prevValues?.conditionPeopleSet?.[index]?.lynApprovalConditions?.[nestkey]
																			?.key !==
																		currentValues?.conditionPeopleSet?.[index]?.lynApprovalConditions?.[nestkey]
																			?.key
																	}
																	noStyle
																>
																	{({ getFieldValue }) => {
																		if (
																			mapInputType[
																				getFieldValue([
																					'taskConditionPeople',
																					'conditionPeopleSet',
																					index,
																					'lynApprovalConditions',
																					nestkey,
																					'key',
																				])
																			]
																				?.toLowerCase()
																				.includes('radio') ||
																			mapInputType[
																				getFieldValue([
																					'conditionPeopleSet',
																					index,
																					'lynApprovalConditions',
																					nestkey,
																					'key',
																				])
																			]
																				?.toLowerCase()
																				.includes('select') ||
																			mapInputType[
																				getFieldValue([
																					'conditionPeopleSet',
																					index,
																					'lynApprovalConditions',
																					nestkey,
																					'key',
																				])
																			]
																				?.toLowerCase()
																				.includes('hradio')
																		) {
																			return (
																				<Form.Item
																					layout="vertical"
																					label="Condition Value"
																					name={[subField1.name, 'operand']}
																					style={{
																						width: '9.5rem',
																					}}
																					validateStatus={
																						index >= prevIndexMap[getFieldValue(['solutionTaskCode'])]
																							? 'error'
																							: ''
																					}
																					rules={[
																						{
																							required: true,
																							message: 'Value is required',
																						},
																					]}
																				>
																					<Select
																						showSearch
																						allowClear
																						style={{
																							width: '100%',
																						}}
																						autoComplete="off"
																						filterOption={filterOptionLabel}
																						placeholder="Select from the list"
																						getPopupContainer={(node) =>
																							node.closest('.MuiDialog-container')
																						}
																						options={controlListMap[
																							getFieldValue([
																								'taskConditionPeople',
																								'conditionPeopleSet',
																								index,
																								'lynApprovalConditions',
																								nestkey,
																								'key',
																							])
																						]?.map((value, i) => ({
																							label: value.label,
																							value: value?.value,
																							key: i,
																						}))}
																					/>
																				</Form.Item>
																			);
																		} else {
																			return (
																				<Form.Item
																					layout="vertical"
																					label="Condition Value"
																					style={{
																						width: '9.5rem',
																					}}
																					validateStatus={
																						index >= prevIndexMap[getFieldValue(['solutionTaskCode'])]
																							? 'error'
																							: ''
																					}
																					name={[subField1.name, 'operand']}
																					rules={[
																						{
																							required: true,
																							message: 'Condition value is required',
																						},
																					]}
																				>
																					<Input placeholder="Enter the Condition Value" />
																				</Form.Item>
																			);
																		}
																	}}
																</Form.Item>

																{!disabled && (
																	<DeleteIconButton
																		disabled={disabled}
																		sx={{ width: '20px', height: '20px' }}
																		onClick={() => {
																			subOpt1.remove(subField1.name);
																		}}
																	/>
																)}
															</Flex>
														))}

														{!disabled && (
															<AddIconButton
																disabled={disabled}
																sx={{ width: '20px', height: '20px' }}
																onClick={() => {
																	subOpt1.add({
																		key: undefined,
																		operand: undefined,
																		operation: undefined,
																	});
																}}
															/>
														)}
													</Flex>
												)}
											</Form.List>
										</TableCell>

										<TableCell sx={{ borderRight: '1px solid #f0f0f0' }}>
											<Form.List layout="vertical" name={[parentField.name, 'lynApprovalPeopleSerial']} initialValue={[{}]}>
												{(subFields2, subOpt2) => (
													<Flex gap="small" justify="flex-start" align="center">
														{subFields2.map((subField2, nestedkey) => (
															<Flex key={subField2.key} justify="space-between" align="center" gap="small">
																<Form.Item
																	layout="vertical"
																	label="Flow  Serial"
																	style={{ width: '8rem' }}
																	name={[subField2.name, 'flow']}
																	initialValue={`${nestedkey + 1}`.toString()}
																>
																	<Input disabled placeholder="Enter the Flow  Name" />
																</Form.Item>

																<Form.Item
																	label="Flow to"
																	layout="vertical"
																	style={{ width: '11rem' }}
																	name={[subField2.name, 'peopleOf']}
																	rules={[
																		{
																			required: true,
																			message: 'Flow to is required',
																		},
																	]}
																>
																	<Select
																		showSearch
																		allowClear
																		autoComplete="off"
																		style={{ width: '100%' }}
																		filterOption={filterOptionLabel}
																		placeholder="Select from the list"
																		getPopupContainer={(node) => node.closest('.MuiDialog-container')}
																		onSelect={() => {
																			form.setFieldValue(
																				[
																					'conditionPeopleSet',
																					index,
																					'lynApprovalPeopleSerial',
																					nestedkey,
																					'value',
																				],
																				undefined
																			);
																		}}
																		options={assignmentTypeOption.map((value, i) => ({
																			label: value.label,
																			value: value?.value,
																			key: i,
																		}))}
																	/>
																</Form.Item>

																<Form.Item
																	noStyle
																	shouldUpdate={(prevValues, currentValues) =>
																		prevValues?.conditionPeopleSet?.[index]?.lynApprovalPeopleSerial?.[nestedkey]
																			?.peopleOf !==
																		currentValues?.conditionPeopleSet?.[index]?.lynApprovalPeopleSerial?.[
																			nestedkey
																		]?.peopleOf
																	}
																>
																	{({ getFieldValue }) => {
																		const flowToValue = getFieldValue([
																			'conditionPeopleSet',
																			index,
																			'lynApprovalPeopleSerial',
																			nestedkey,
																			'peopleOf',
																		]);
																		let content;

																		if (flowToValue === 'identityField') {
																			content = (
																				<>
																					<Form.Item
																						layout="vertical"
																						label="Value Type"
																						name={[subField2.name, 'valueType']}
																						style={{
																							width: '14rem',
																						}}
																						rules={[
																							{
																								required: true,
																								message: `Value Type is required`,
																							},
																						]}
																					>
																						<Select
																							showSearch
																							autoComplete="off"
																							filterOption={filterOptionLabel}
																							placeholder="Select from the list"
																							options={finalPeopleOptions[flowToValue]}
																							getPopupContainer={(node) =>
																								node.closest('.MuiDialog-container')
																							}
																							style={{
																								width: '100%',
																							}}
																						/>
																					</Form.Item>
																				</>
																			);
																		}

																		return (
																			<>
																				<>
																					<Form.Item
																						layout="vertical"
																						name={[subField2.name, 'value']}
																						label={dropDownLabel[flowToValue] ?? 'No Label'}
																						style={{
																							width: '14rem',
																						}}
																						rules={[
																							{
																								required: true,
																								message: `${dropDownLabel[flowToValue] ?? ' '} is required`,
																							},
																						]}
																					>
																						<Select
																							showSearch
																							autoComplete="off"
																							filterOption={filterOptionLabel}
																							placeholder="Select from the list"
																							options={finalPeopleOptions[flowToValue]}
																							getPopupContainer={(node) =>
																								node.closest('.MuiDialog-container')
																							}
																							style={{
																								width: '100%',
																							}}
																						/>
																					</Form.Item>
																				</>

																				{content}
																			</>
																		);
																	}}
																</Form.Item>

																{!disabled && (
																	<DeleteIconButton
																		disabled={disabled}
																		sx={{ width: '20px', height: '20px' }}
																		onClick={() => {
																			subOpt2.remove(subField2.name);
																		}}
																	/>
																)}
															</Flex>
														))}

														{!disabled && (
															<AddIconButton
																disabled={disabled}
																sx={{ width: '20px', height: '20px' }}
																onClick={() => {
																	subOpt2.add({
																		flow: undefined,
																		peopleOf: undefined,
																		value: undefined,
																	});
																}}
															/>
														)}
													</Flex>
												)}
											</Form.List>
										</TableCell>

										<TableCell style={{ display: 'flex' }}>
											<Flex align="center" gap="small">
												<Form.Item
													label="SLA Type"
													layout="vertical"
													style={{ width: '11rem' }}
													name={[parentField.name, 'lynApprovalSLA', 'slaCode']}
												>
													<Select
														showSearch
														allowClear
														autoComplete="off"
														style={{ width: '100%' }}
														filterOption={filterOptionLabel}
														placeholder="Select from the list"
														getPopupContainer={(node) => node.closest('.MuiDialog-container')}
														onSelect={(value) => {
															const slaItem = SLAList.find((item) => item.code === value);

															form.setFieldValue(
																['conditionPeopleSet', index, 'lynApprovalSLA', 'slaId'],
																slaItem?.index
															);
														}}
														options={SLAList.map((value, i) => ({
															label: value.code,
															value: value?.code,
															key: i,
														}))}
													/>
												</Form.Item>

												<Form.Item
													layout="vertical"
													label="SLA Duration"
													style={{ width: '11rem' }}
													name={[parentField.name, 'lynApprovalSLA', 'duration']}
												>
													<InputNumber style={{ width: '100%' }} placeholder="Write here" autoComplete="off" />
												</Form.Item>

												<Form.Item
													layout="vertical"
													label="Time Unit"
													style={{ width: '11rem' }}
													name={[parentField.name, 'lynApprovalSLA', 'unit']}
												>
													<Select
														showSearch
														allowClear
														autoComplete="off"
														style={{ width: '100%' }}
														filterOption={filterOptionLabel}
														placeholder="Select from the list"
														getPopupContainer={(node) => node.closest('.MuiDialog-container')}
														options={timestamp.map((value, i) => ({
															label: value.label,
															value: value?.value,
															key: i,
														}))}
													/>
												</Form.Item>
											</Flex>
										</TableCell>

										{!disabled && (
											<TableCell>
												<DeleteIconButton
													disabled={disabled}
													sx={{ width: '20px', height: '20px' }}
													onClick={() => {
														parentOpt.remove(parentField.name);

														const taskCode = form.getFieldValue(['solutionTaskCode']);

														setPrevIndexMap((prev) => ({
															...prev,
															[taskCode]: prev[taskCode] - 1,
														}));
													}}
												/>
											</TableCell>
										)}
									</TableRow>
								))}

								{!disabled && (
									<TableRow>
										<TableCell>
											<Flex
												align="flex-start"
												justify="flex-start"
												key={parentFields?.length + '' + Math.floor(Math.random() * 100000) + ''}
											>
												<AddIconButton
													disabled={disabled}
													sx={{ width: '20px', height: '20px' }}
													onClick={() => {
														const taskCode = form.getFieldValue(['solutionTaskCode']);

														if (editList && structure?.conditionPeopleSet?.[0]) {
															parentOpt.add(structure?.conditionPeopleSet[0]);

															setPrevIndexMap((prev) => ({
																...prev,
																[taskCode]: prev[taskCode] + 1,
															}));
														} else {
															parentOpt.add({
																lynApprovalConditions: [
																	{
																		key: undefined,
																		operation: undefined,
																		operand: undefined,
																	},
																],
																lynApprovalPeopleSerial: [
																	{
																		flow: '1',
																		peopleOf: undefined,
																		value: undefined,
																	},
																],
																lynApprovalSLA: {
																	slaCode: undefined,
																	duration: undefined,
																	unit: undefined,
																},
															});

															setPrevIndexMap((prev) => ({
																...prev,
																[taskCode]: prev[taskCode] + 1,
															}));
														}
													}}
												/>
											</Flex>
										</TableCell>
									</TableRow>
								)}
							</TableBody>
						</Table>
					</TableContainer>

					{!disabled && (
						<Stack direction="row" justifyContent="flex-end" sx={{ mt: '20px', gap: '12px' }}>
							<ActionButton onClick={handleDelete} tooltip="Delete" variantType="reject" label="Delete" />

							<ActionButton
								label="Save"
								tooltip="Save"
								variantType="save"
								onClick={() => {
									form.validateFields()
										.then((values) => {
											onClose();
										})
										.catch((error) => {
											console.log('Invalid:', error);
										});
								}}
							/>
						</Stack>
					)}
				</Box>
			</DialogContent>
		</Dialog>
	);
};

export default ConditionSetModal;
